import React from 'react';
import { AppShell } from './AppShell';
import { AREA_LABELS } from './areaSwitch';
import { staffNavigation } from '../workspaces/staff/staffNavigation';

/** The staff only has the platform side, and it is named like everyone's. */
export const StaffLayout = () => <AppShell navigation={staffNavigation} areaLabel={AREA_LABELS.oms} />;
